<template>
  <div class="aplayer-lrc">
    <div class="aplayer-lrc-contents" :style="transformStyle" v-if="lrcLines.length">
      <p v-for="(line, index) of lrcLines" :key="index" :class="{ 'aplayer-lrc-current': index === currentLineIndex }">{{ line[1] }}</p>
    </div>
    <p style="height:190px;overflow-y:auto;white-space:normal;" v-else v-html="displayLrc.replace(/\n/g, '<br />')"></p>
  </div>
</template>

<script>
// import { parseLrc } from '../utils'

export default {
  props: {
    currentMusic: {
      type: Object,
      required: true
    },
    playStat: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      displayLrc: '',
      currentLineIndex: 0
    }
  },
  computed: {
    lrcLines() {
      return this.$utils.parseLrc(this.displayLrc)
    },
    currentLine() {
      if (this.currentLineIndex > this.lrcLines.length - 1) {
        return null
      }
      return this.lrcLines[this.currentLineIndex]
    },
    transformStyle() {
      // transform: translateY(0); -webkit-transform: translateY(0);
      return {
        transform: `translateY(${-this.currentLineIndex * 32 + 80}px)`,
        webkitTransform: `translateY(${-this.currentLineIndex * 32 + 80}px)`
      }
    }
  },
  methods: {
    applyLrc(lrc) {
      if (/^https?:\/\//.test(lrc)) {
        this.fetchLrc(lrc)
      } else {
        this.displayLrc = lrc
      }
    },
    fetchLrc(src) {
      let myHeaders = new Headers()

      myHeaders.append('Content-Type', 'text/xml')
      fetch(src, myHeaders)
        .then(response => response.text())
        .then(lrc => {
          this.displayLrc = lrc
          // console.log(lrc)
        })
    },
    hideLrc() {
      this.displayLrc = ''
    }
  },
  watch: {
    currentMusic: {
      immediate: true,
      handler(music) {
        this.currentLineIndex = 0
        if (music.lyricUrl) {
          this.applyLrc(music.lyricUrl)
        } else {
          this.hideLrc()
        }
      }
    },
    'playStat.playedTime'(playedTime) {
      for (let i = 0; i < this.lrcLines.length; i++) {
        const line = this.lrcLines[i]
        const nextLine = this.lrcLines[i + 1]
        if (playedTime >= line[0] && (!nextLine || playedTime < nextLine[0])) {
          this.currentLineIndex = i
        }
      }
    }
  }
}
</script>
<style lang="less">
.aplayer-lrc {
  position: relative;
  height: 150px;
  text-align: center;
  overflow: hidden;
  // margin-bottom: 7px;
  min-height: 200px;

  // &:before {
  //   position: absolute;
  //   top: 0;
  //   z-index: 1;
  //   display: block;
  //   overflow: hidden;
  //   width: 100%;
  //   height: 10%;
  //   content: ' ';
  //   background: -moz-linear-gradient(top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  //   background: -webkit-linear-gradient(
  //     top,
  //     rgba(255, 255, 255, 1) 0%,
  //     rgba(255, 255, 255, 0) 100%
  //   );
  //   background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  //   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);
  // }

  // &:after {
  //   position: absolute;
  //   bottom: 0;
  //   z-index: 1;
  //   display: block;
  //   overflow: hidden;
  //   width: 100%;
  //   height: 33%;
  //   content: ' ';
  //   background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 100%);
  //   background: -webkit-linear-gradient(
  //     top,
  //     rgba(255, 255, 255, 0) 0%,
  //     rgba(255, 255, 255, 0.8) 100%
  //   );
  //   background: linear-gradient(
  //     to bottom,
  //     rgba(255, 255, 255, 0) 0%,
  //     rgba(255, 255, 255, 0.8) 100%
  //   );
  //   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ccffffff', GradientType=0);
  // }

  p {
    font-size: 14px;
    color: #666;
    line-height: 32px;
    height: 32px;
    padding: 0;
    margin: 0;
    transition: all 0.5s ease-out;
    opacity: 0.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.aplayer-lrc-current {
      opacity: 1;
      overflow: visible;
      white-space: normal;
      text-overflow: clip;
      height: initial;
      min-height: 32px;
      color: #4b85ff;
    }
  }

  .aplayer-lrc-contents {
    width: 100%;
    transition: all 0.5s ease-out;
    user-select: text;
    padding: 0 20px;
    cursor: default;
  }
}
</style>
